export var getComputedStyle = function (el) {
    return window.getComputedStyle(el);
};
